<template lang="pug">
  div.neutral700--text
    template(v-if="!disabled")
      .text-sm.font-semibold.mb-2 Redeeming person
      search-customer-dropdown.mt-2.mb-8(v-if="customerSelectable" v-model="selectedCustomer" @change="handleChangeSelection")
      v-text-field.round-xl.mb-8(v-else-if="customer" :value="customer.name" dense height="48" outlined readonly hide-details)
    template(v-if="selectedCustomer")
      .text-sm.font-semibold.mb-2 Choose which offer you would like to redeem
      redeem-offer-list-item(ref="redeemOfferListItem" :customer="customer" :lead-id="leadId" :value="value" @input="$emit('input', $event)")
</template>

<script>
import RedeemOfferListItem from "@/components/clinic/checkout/marketing/redeem/offer/RedeemOfferListItem.vue";
import SearchCustomerDropdown from "@/components/clinic/marketing/SearchCustomerDropdown.vue";

export default {
  components: {
    SearchCustomerDropdown, RedeemOfferListItem,
  },
  props: {
    value: {
      type: Object,
      default: null
    },
    customer: {
      type: Object,
      default: null
    },
    leadId: {
      type: Number,
      default: null
    },
    customerSelectable: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      selectedCustomer: null,
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.selectedCustomer = this.customer
    })
  },
  methods: {
    handleChangeSelection() {
      this.$emit('update:customer', this.selectedCustomer)
      this.$emit('input', null)
      this.$nextTick(() => {
        this.$refs.redeemOfferListItem.fetchCoupons()
      })
    }
  },
}
</script>

<style scoped>
</style>